import React from 'react';
import { connect } from 'react-redux';

import { getProfileFetches, getProfile } from '~/accounts/signup/selectors';
import { profileCreate, profileFetch } from '../actions';

import UserProfileView from '../components/UserProfileView';

const UserProfileContainer = props => <UserProfileView {...props} />;

const mapStateToProps = state => ({
  profileFetches: getProfileFetches(state),
  profile: getProfile(state)
});

const mapDispatchToProps = dispatch => ({
  profileCreateAction: (...p) => dispatch(profileCreate(...p)),
  profileFetchAction: () => dispatch(profileFetch())
});

export default connect(mapStateToProps, mapDispatchToProps)(UserProfileContainer);
